import { TYPES } from "./bailiff_dialog.type";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const app = getApp();
const bucket = "gs://vi-viet-nam-bailiff-draft";
const storage = getStorage(app, bucket);
const auth = getAuth(app);

// ========= firebase function =========//
// ========= cloud function =========//
export const getAudioUrlFromBailiff =
  ({ id }, callback) =>
  (dispatch) => {
    setBailiffDialogUrlAudioSuccess(dispatch, null);
    const uid = auth?.currentUser?.uid;
    console.log({ uid });
    const path = `bailiff/audio/${id}/raw.mp3`;
    console.log({ path });
    const refstorage = ref(storage, path);
    getDownloadURL(refstorage)
      .then((url) => {
        console.log({ url });
        setBailiffDialogUrlAudioSuccess(dispatch, url);
      })
      .catch((err) => {
        console.log({ err });
      });
  };
// ========= cloud function =========//
// ========= local function =========//
export const setBailiffDialogSecond = (data, callback) => (dispatch) => {
  setBailiffDialogSecondSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDialogPlay = (data, callback) => (dispatch) => {
  setBailiffDialogPlaySuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDialogSlot = (data, callback) => (dispatch) => {
  setBailiffDialogSlotSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDialogKick = (data, callback) => (dispatch) => {
  setBailiffDialogKickSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const resetAll = (callback) => (dispatch) => {
  setBailiffDialogPlaySuccess(dispatch, false);
  setBailiffDialogSlotSuccess(dispatch, 0);
  setBailiffDialogSecondSuccess(dispatch, 0);
  setBailiffDialogKickSuccess(dispatch, null);
};

// ========= dispatch =========//
const setBailiffDialogUrlAudioSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_URL_AUDIO,
    payload: data,
  });
};

const setBailiffDialogSecondSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_SECOND,
    payload: data,
  });
};

const setBailiffDialogPlaySuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_PLAY,
    payload: data,
  });
};

const setBailiffDialogSlotSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_SLOT,
    payload: data,
  });
};

const setBailiffDialogKickSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_KICK,
    payload: data,
  });
};
